export function templateKey(sportId, marketId) {
    return `${sportId}_${marketId}`;
}
export function convertConfig(cardConfig) {
    const map = new Map();
    const objectKeys = Object.keys(cardConfig);
    objectKeys.forEach(key => {
        cardConfig[key].markets.forEach(m => {
            map.set(templateKey(key, m.idLive), m.template);
            map.set(templateKey(key, m.idPreLive), m.template);
        });
    });
    return map;
}
//# sourceMappingURL=convertConfig.js.map